import React, { useState, useLayoutEffect, useRef } from 'react';
import './infographics.scss';
import { useCountUp } from 'react-countup';
import { gsap } from '../../gsap';
import { lang } from '../lang';

function Infographic1() {
  const [showCounter, setShowCounter] = useState(false);
  const infographicStatRef = useRef();
  const infographicRowRef = useRef();
  const plusRef = useRef();
  const { plus, stat, plusclass } = lang.infographic[0];

  const SimpleHook = () => {
    useCountUp({
      ref: 'counter',
      end: 60,
      start: 0,
      duration: 1.2
    });
    return <span id="counter" />;
  };

  useLayoutEffect(() => {
    gsap.set([plusRef.current, infographicStatRef.current, infographicRowRef.current], {
      opacity: 0
    });
    const tl = gsap.timeline();
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0.4) {
            setShowCounter(true);
            tl.to(plusRef.current, { opacity: 1, duration: 1, ease: 'ease-in' }, '+=.3')
              .to(
                infographicStatRef.current,
                {
                  opacity: 1,
                  duration: 0.8,
                  ease: 'ease-in'
                },
                '>'
              )
              .to(
                infographicRowRef.current,
                {
                  opacity: 1,
                  duration: 0.8,
                  ease: 'ease-in'
                },
                '>-0.3'
              );
          }
        });
      },
      { threshold: [0, 0.4] }
    );
    observer.observe(plusRef.current);
  }, []);

  return (
    <div className="infographics__content infographics__content-0">
      <div className="infographics__map">
        <img src="https://courageous-cdn-media-bucket.s3.amazonaws.com/regeneron/map.jpg" alt="" />
        <div className="infographics__map__stat">
          <div className="infographics__map__stat__num bluegradient">
            {showCounter ? <SimpleHook /> : `0`}
            <span ref={plusRef} className={plusclass}>
              {plus}
            </span>
          </div>
          <p className="blue" ref={infographicStatRef}>
            {stat[0]}
          </p>
        </div>
      </div>
      <div className="infographics__row infographics__row-0" ref={infographicRowRef}>
        <div className="infographics__row__item">
          <div className="bluegradient infographics__row__num">
            175,000
            <span className="infographics__row__num infographics__row__num--s">名</span>
          </div>
          <p className="infographics__row__copy">{stat[1]}</p>
        </div>
        <div className="infographics__row__item">
          <div className="bluegradient infographics__row__num">420+</div>
          <p className="infographics__row__copy">{stat[2]}</p>
        </div>
      </div>
    </div>
  );
}

export default Infographic1;
